import type { ContentBlock, SelectionDraft } from './types';

/** Every canonical span declares its UTF-16 offset. Glosses have no canonical span. */
export function captureRange(selection: Selection | null, blocks: ContentBlock[]): SelectionDraft | null {
  if (!selection || selection.isCollapsed || !selection.rangeCount) return null;
  const range=selection.getRangeAt(0);
  const element=(node:Node)=>node instanceof Element?node:node.parentElement;
  const startBlock=element(range.startContainer)?.closest('[data-block-id]');
  const endBlock=element(range.endContainer)?.closest('[data-block-id]');
  if (!startBlock || !endBlock) throw new Error('Выделение выходит за пределы текста');
  const fragments: SelectionDraft[]=[];
  const spans=Array.from(document.querySelectorAll<HTMLElement>('[data-canonical-start]'));
  for(const span of spans){
    if(span.closest('details:not([open])')) continue;
    if(!span.getClientRects().length) continue;
    if(!range.intersectsNode(span)) continue;
    const block=blocks.find(b=>b.id===span.closest('[data-block-id]')?.getAttribute('data-block-id'));
    if(!block) continue;
    const language=span.dataset.language==='ru'?'ru':'en';
    const canonical=language==='en'?block.enText:block.ruText;
    const prefix=range.cloneRange(); prefix.selectNodeContents(span);
    let start=Number(span.dataset.canonicalStart),end=start+(span.textContent?.length??0);
    if(span.contains(range.startContainer)){prefix.setEnd(range.startContainer,range.startOffset); start+=prefix.toString().length;}
    if(span.contains(range.endContainer)){prefix.selectNodeContents(span);prefix.setEnd(range.endContainer,range.endOffset);end=Number(span.dataset.canonicalStart)+prefix.toString().length;}
    if(end<=start) continue;
    const last=fragments.at(-1);
    if(last && last.block.id===block.id && last.language===language && last.end===start){last.end=end;last.quote=canonical.slice(last.start,end);}
    else fragments.push({block,language,start,end,quote:canonical.slice(start,end)});
  }
  if(!fragments.length) throw new Error('Выделены только пояснения. Выберите исходный текст.');
  // A range must not silently include the repeated representation twice.
  const unique=fragments.filter((f,i)=>!fragments.slice(0,i).some(p=>p.block.id===f.block.id&&p.language===f.language&&p.start===f.start&&p.end===f.end));
  return {...unique[0],quote:unique.map(f=>f.quote).join('\n'),fragments:unique.map(({block,...f})=>({...f,exactQuote:f.quote,blockId:block.id,textHash:block.textHash,prefix:(f.language==='en'?block.enText:block.ruText).slice(Math.max(0,f.start-32),f.start),suffix:(f.language==='en'?block.enText:block.ruText).slice(f.end,f.end+32)}))};
}

